// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/ActionsAction/Content/Content/CopyAction/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Charges_ActionsAction_Content_Content_CopyAction(
  $objects: [vaxiom_misc_fee_charge_templates_insert_input!]!
) {
  insert_vaxiom_misc_fee_charge_templates(objects: $objects) {
    affected_rows
  }
}

`